/**
 * Device identification utility for persistent browser-based tracking.
 * Safe for SSR environments.
 */

const IS_BROWSER = typeof window !== 'undefined';
const STORAGE_KEY = 'device_id';
const LEGACY_STORAGE_KEY = 'cartToken';

/**
 * Generates or retrieves a persistent device identifier.
 * Reuses existing legacy 'cartToken' for backward compatibility if available.
 */
export const getDeviceId = () => {
    if (!IS_BROWSER) return '';

    let deviceId = localStorage.getItem(STORAGE_KEY);

    // Backward compatibility: check for old key
    if (!deviceId) {
        deviceId = localStorage.getItem(LEGACY_STORAGE_KEY);
        if (deviceId) {
            localStorage.setItem(STORAGE_KEY, deviceId);
        }
    }

    // Generate new if none exists
    if (!deviceId) {
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
            deviceId = crypto.randomUUID();
        } else {
            // Fallback for older browsers
            deviceId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        }
        localStorage.setItem(STORAGE_KEY, deviceId);
    }

    return deviceId;
};

/**
 * Collects standard device metadata for identification/analytics.
 */
export const getDeviceInfo = () => {
    if (!IS_BROWSER) {
        return {
            deviceId: '',
            userAgent: 'SSR',
            platform: 'SSR',
            language: 'SSR',
            screen: 'Unknown',
        };
    }

    return {
        deviceId: getDeviceId(),
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language,
        screen: `${window.screen.width}x${window.screen.height}`,
    };
};
